<template>
  <v-list class="course-steps-list my-4">
    <draggable
      @change="stepDragged"
      v-model="steps"
      handle=".course-steps-list-item__drag-handle"
      group="course-steps"
      @start="drag = true"
      @end="drag = false"
      :disabled="readonly"
    >
      <course-steps-list-item
        v-for="(step, stepIndex) in steps"
        :key="`course-step-list-item-${step.id}-${stepIndex}`"
        :id="step.id"
        :title="step.title"
        :description="step.description"
        :static-media-thumbnail-url="step.staticMediaThumbnailUrl"
        :attachment-url="step.attachmentUrl"
        :thumbnail-url="step.thumbnailUrl"
        :media-url="step.mediaUrl"
        :link="step.link"
        @open-edit="openEdit"
        @open-delete="openDelete"
        @refresh-course-step-media="refreshCourseStepsMedia"
        :readonly="readonly"
      />
    </draggable>
  </v-list>
</template>

<script>
import draggable from 'vuedraggable'
import CourseStepsListItem from '@/components/courses/CourseStepsListItem.vue'

export default {
  components: { draggable, CourseStepsListItem },
  name: 'CourseStepsList',
  mixins: [],
  props: {
    courseSteps: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    drag: false,
    steps: [],
  }),
  mounted() {
    this.steps = this.courseSteps
  },
  computed: {},
  methods: {
    openEdit(step) {
      this.$emit('open-edit', step)
    },
    openDelete(step) {
      this.$emit('open-delete', step)
    },
    refreshCourseStepsMedia() {
      this.$emit('refresh-course-steps-media')
    },
    stepDragged(props) {
      if (props?.moved) {
        const { newIndex, oldIndex } = props.moved
        if (oldIndex === newIndex) return
        const nextStep = this.steps?.[newIndex + 1] || null
        const prevStep = this.steps?.[newIndex - 1] || null
        this.$emit('step-dragged', {
          ...props,
          nextStep,
          prevStep,
        })
        return
      }
      this.$emit('step-dragged', props)
    },
  },
  watch: {
    courseSteps: {
      handler: function(newValue) {
        this.steps = newValue
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss">
.course-steps-list {
  background: transparent !important;
}
</style>
